import { Observable } from "rxjs";

import st from "lib/utils/index";
import { AccountRepository } from "lib/repositories/index";
import { setCurrentUser } from "modules/auth/actions";
import { pushRoute } from "modules/app/actions";
import { createFormInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "auth/ResetPasswordView/INITIALIZE_VIEW";
export const INITIALIZE_MODEL = "auth/ResetPasswordView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "auth/ResetPasswordView/UPDATE_MODEL";
export const VALIDATE = "auth/ResetPasswordView/VALIDATE";
export const SUBMIT = "auth/ResetPasswordView/SUBMIT";
export const FETCH_SUBMIT_START = "auth/ResetPasswordView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "auth/ResetPasswordView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "auth/ResetPasswordView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.auth.ResetPasswordView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  stateKey: "form",
  successAlertContent: () => "Twoje hasło zostało pomyślnie zmienione. Zalogowaliśmy Cię na Twoje konto.",
  successAlertTimeout: 5000,
  withFailureAlert: false,
  updateModelAfterSubmit: false,
  mergeFailureAlertIntoErrors: true,
  validate: ({ form: { model } }, errors) => {
    errors.add(`model.password`, st.validators.presence(model.password));
    errors.add(`model.password_confirmation`, st.validators.presence(model.password_confirmation));
  },
  submitModel: ({
    form: {
      model: { reset_password_token, password, password_confirmation },
    },
  }) => {
    return AccountRepository.resetPassword({ reset_password_token, password, password_confirmation });
  },
});

const initialState = {
  form: formInstance.initialState,
  viewOptions: {
    redirectAfterLogin: null,
  },
};

const reducers = {
  ...formInstance.reducersMap,

  [INITIALIZE_VIEW]: (state, { viewOptions }) => {
    return {
      ...initialState,
      viewOptions,
    };
  },
};

const epics = [
  ...formInstance.epics,

  (actions$, { getState }) =>
    actions$.ofType(FETCH_SUBMIT_SUCCESS).flatMap(
      ({
        model: {
          user,
          meta: { auth_token },
        },
      }) => {
        const {
          viewOptions: { redirectAfterLogin },
        } = stateSelector(getState());
        return Observable.of(setCurrentUser({ user, auth_token }), pushRoute(redirectAfterLogin || "/"));
      }
    ),
];

export function initializeView(viewOptions = {}) {
  return { type: INITIALIZE_VIEW, viewOptions };
}

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/auth/ResetPasswordView/index.js